export function getSavingPercentage(annualPrice: number, monthlyPrice: number) {
  if (annualPrice && monthlyPrice) {
    const monthlyAnnualCost = monthlyPrice * 12;
    const savingsPercentage =
      ((monthlyAnnualCost - annualPrice) / monthlyAnnualCost) * 100;

    return Math.round(savingsPercentage);
  }
}
